/**
 * VendorForgotPassword — request a vendor/sub password reset link.
 * Route: /vendor/forgot-password
 */

import { useState, FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { vendorForgotPassword } from '../../api/vendor'

export default function VendorForgotPassword() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setSuccess(false)
    setSubmitting(true)
    try {
      await vendorForgotPassword(email.trim())
      setSuccess(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send reset email')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 380,
        background: '#fff',
        border: '1px solid var(--line)',
        borderRadius: 'var(--r)',
        padding: '28px 24px',
      }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: 'var(--ink)', margin: '0 0 6px' }}>
          Forgot password
        </h1>
        <p style={{ fontSize: 12, color: 'var(--ink4)', margin: '0 0 22px', lineHeight: 1.5 }}>
          Enter your vendor email and we&apos;ll send a link to reset your password.
        </p>

        {success ? (
          <p
            style={{ fontSize: 13, color: 'var(--ink3)', margin: 0, lineHeight: 1.5 }}
            role="status"
            data-testid="vendor-forgot-success"
          >
            If a vendor account exists for that email, we&apos;ve sent a reset link. Check your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', marginBottom: 18 }}>
              <span style={{ display: 'block', fontSize: 11, fontWeight: 600, color: 'var(--ink3)', marginBottom: 6 }}>
                Email
              </span>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="fld-i"
                data-testid="vendor-forgot-email"
                style={{ width: '100%', padding: '10px 12px', fontSize: 14 }}
              />
            </label>

            {error && (
              <p style={{ fontSize: 12, color: 'var(--red)', margin: '0 0 14px' }} role="alert">
                {error}
              </p>
            )}

            <button
              type="submit"
              className="btn b-dk"
              disabled={submitting}
              data-testid="vendor-forgot-submit"
              style={{ width: '100%', justifyContent: 'center', padding: '10px 16px', fontWeight: 600 }}
            >
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <p style={{ fontSize: 12, color: 'var(--ink4)', margin: '18px 0 0', textAlign: 'center' }}>
          <Link to="/vendor/login" style={{ color: 'var(--ink3)', textDecoration: 'none', fontWeight: 600 }}>
            ← Back to vendor sign in
          </Link>
        </p>
      </div>
    </div>
  )
}
